export default __webpack_public_path__ + "static/media/right.adcba9da.svg";